$shm_button_open $mol_button_open
	sub /
		<= Icon
		<= title
		<= Native
